import {
	Button,
	DialogContent,
	DialogContentText,
	DialogActions,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Table,
	TableContainer,
	useTheme,
	useMediaQuery,
	Grid,
} from "@mui/material"
import Notifications from "../../AlertMessage/Notifications"
import PrintIcon from "@mui/icons-material/Print"
import MailOutlineIcon from "@mui/icons-material/MailOutline"
import GetAppIcon from "@mui/icons-material/GetApp"
import Loader from "../../../utils/Loader"
import dayjs from 'dayjs'

const classes: any = {
	tableRow: {
		borderBottom: "none",
		textAlign: "right",
		padding: 0,
		paddingRight: "15px",
	},
	tableCell: {
		textAlign: "left",
		p: 1,
	},
	tableHeader: {
		backgroundColor: "darkgray",
		textAlign: "left",
		padding: "4px",
		fontSize: "medium",
		fontWeight: "bold",
	},
}
export default function InvoiceTemplate(props: any) {
	const {
		invoiceDetails,
		messages,
		errors,
		userConfig,
		userInfo,
		pdfRequesting,
		pdfSuccessful,
		clubData,
	} = props
	let pdf: any = props.invoicePdf

	const printInvoice = () => {
		printPreview()
	}
	const downloadInvoice = () => {
		download()
	}
	const emailInvoice = () => {
		let config: any = {
			headers: {
				Authorization: `Bearer ${userConfig?.token}`,
			},
			partnerApiKey: userConfig?.partnerApiKey,
			businessAlias: userConfig?.businessAlias,
			invoiceIds: [invoiceDetails[0]?.invoiceId],
			clientId: userInfo?.id,
			email: userInfo?.email,
		}
		props.emailInvoice(config)
	}
	const download = () => {
		const linkSource = `data:application/pdf;base64,${pdf}`
		const downloadLink = document.createElement("a")
		const fileName = `Invoice_${invoiceDetails[0]?.invoiceId}.pdf`
		downloadLink.href = linkSource
		downloadLink.download = fileName
		downloadLink.click()
	}
	const formatCurrency = (amount: any) => {
		return (
			clubData?.currencyPrefix +
			amount?.toFixed(2) +
			" " +
			clubData?.currencyPostfix
		)
	}
	const dataURItoBlob = (dataURI: any) => {
		const byteString = window.atob(dataURI)
		const arrayBuffer = new ArrayBuffer(byteString.length)
		const int8Array = new Uint8Array(arrayBuffer)
		for (let i = 0; i < byteString.length; i++) {
			int8Array[i] = byteString.charCodeAt(i)
		}
		const blob = new Blob([int8Array], { type: "application/pdf" })
		return blob
	}
	const blob = dataURItoBlob(pdf)
	const url = URL.createObjectURL(blob)
	const printPreview = (type = "application/pdf") => {
		const theWindow: any = window.open(url)
		const theDoc = theWindow.document
		const theScript = document.createElement("script")
		function injectThis() {
			window.print()
		}
		theScript.innerHTML = `window.onload = ${injectThis.toString()};`
		theDoc.body.appendChild(theScript)
	}
	const theme = useTheme()
	const matches = useMediaQuery(theme.breakpoints.down("sm"))

	return (
		<>
			{invoiceDetails ? (
				<>
					{messages || errors ? (
						<Notifications messages={messages} errors={errors} />
					) : null}
					<DialogActions>
						<Grid container spacing={2} justifyContent="center" sx={{ width: "100%" }}>
							<Grid>
								<Button
									variant="contained"
									color="primary"
									onClick={() => printInvoice()}
									disabled={pdfRequesting || !pdfSuccessful}
									startIcon={matches ? "" : <PrintIcon />}
								>
									{matches ? <PrintIcon /> : "Print"}
								</Button>
							</Grid>
							<Grid>
								<Button
									onClick={() => downloadInvoice()}
									variant="contained"
									color="primary"
									disabled={pdfRequesting || !pdfSuccessful}
									startIcon={matches ? "" : <GetAppIcon />}
								>
									{matches ? <GetAppIcon /> : "Download"}
								</Button>
							</Grid>
							<Grid>
								<Button
									onClick={() => emailInvoice()}
									variant="contained"
									color="primary"
									startIcon={matches ? "" : <MailOutlineIcon />}
								>
									{matches ? <MailOutlineIcon /> : "Email"}
								</Button>
							</Grid>
						</Grid>
					</DialogActions>
					<DialogContent>
						<DialogContentText
							sx={{ maxWidth: "100%", overflow: "auto", color: "black" }}
						>
							<Grid
								container
								justifyContent="space-between"
								sx={{ fontSize: ".875rem" }}
							>
								<Grid>
									{invoiceDetails[0]?.club?.logoPath ? (
										<img
											style={{ width: 100 }}
											src={invoiceDetails[0]?.club?.logoPath}
											alt="Club Logo"
										/>
									) : (
										" "
									)}
								</Grid>
								<Grid sx={{ textAlign: "right", pt: 2 }}>
									{invoiceDetails[0]?.club?.clubName}
									<br />
									{invoiceDetails[0]?.club?.address}
									<br />
									{`${invoiceDetails[0]?.club?.city}, 
									${invoiceDetails[0]?.club?.state} 
									${invoiceDetails[0]?.club?.country} 
									${invoiceDetails[0]?.club?.zip}`}
								</Grid>
							</Grid>
							<Grid
								container
								justifyContent="flex-start"
								sx={classes.tableHeader}
							>
								Invoice Information
							</Grid>
							<Grid
								container
								justifyContent="flex-start"
								sx={{ fontSize: ".875rem", pl: 1 }}
							>
								<Grid size={{xs: 5, sm: 3, md: 2}}>
									Invoice # :
								</Grid>
								<Grid size={{xs: 7, sm: 9, md: 10}}>
									{invoiceDetails[0]?.invoiceId}
								</Grid>

								<Grid size={{xs: 5, sm: 3, md: 2}}>
									Invoice Date :
								</Grid>
								<Grid size={{xs: 7, sm: 9, md: 10}}>
									{dayjs(invoiceDetails[0]?.invoiceDate.slice(0, 10)).format(
										"MM/DD/YYYY"
									)}
								</Grid>

								<Grid size={{xs: 5, sm: 3, md: 2}}>
									Sold to :
								</Grid>
								<Grid size={{xs: 7, sm: 9, md: 10}}>
									{invoiceDetails[0]?.soldTo?.fullName}
								</Grid>

								<Grid size={{xs: 5, sm: 3, md: 2}}>
									Sold by :
								</Grid>
								<Grid size={{xs: 7, sm: 9, md: 10}}>
									{invoiceDetails[0]?.soldByFullName}
								</Grid>
							</Grid>
							<Grid container>
								<Grid size={{xs: 12}} sx={{...classes.tableHeader}}>
									Invoice Details
								</Grid>
								<TableContainer sx={{ overflowX: "auto" }}>
									<Table
										sx={{ "& .MuiTableCell-root": { ...classes.tableCell } }}
									>
										<TableHead>
											<TableCell
												sx={{
													minWidth: 150,
												}}
											>
												Item
											</TableCell>
											<TableCell
												sx={{
													minWidth: 120,
												}}
											>
												Date
											</TableCell>
											<TableCell>Purchased For</TableCell>
											<TableCell>Quantity</TableCell>
											<TableCell>Price</TableCell>
											<TableCell>Discount</TableCell>
											<TableCell
												sx={{
													minWidth: 90,
												}}
											>
												Tax
											</TableCell>
											<TableCell
												style={{ textAlign: "right", paddingRight: "15px" }}
											>
												Amount
											</TableCell>
										</TableHead>
										<TableBody sx={{ overflow: "auto" }}>
											{invoiceDetails[0]?.invoiceItems?.map(
												(item: any, index: any) => (
													<TableRow key={index}>
														<TableCell style={{ textAlign: "left" }}>
															{item.itemName}
														</TableCell>
														<TableCell>
															{dayjs(item.date.slice(0, 10)).format(
																"MM/DD/YYYY"
															)}
														</TableCell>
														<TableCell>{item.purchasedFor}</TableCell>
														<TableCell>{item.quantity}</TableCell>
														<TableCell>{formatCurrency(item.price)}</TableCell>
														<TableCell>
															{formatCurrency(item.discount)}
														</TableCell>
														<TableCell style={{ minWidth: 60 }}>
															{item.taxPercent} %
														</TableCell>
														<TableCell
															style={{
																textAlign: "right",
																paddingRight: "15px",
															}}
														>
															{formatCurrency(item.amount)}
														</TableCell>
													</TableRow>
												)
											)}
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>
							<Grid container justifyContent="flex-end">
								<Table sx={{ maxWidth: 300 }}>
									<TableBody>
										<TableRow>
											<TableCell sx={classes.tableRow}>
												Item(s) Total:
											</TableCell>
											<TableCell sx={classes.tableRow}>
												{formatCurrency(
													invoiceDetails[0]?.totalAmountBeforeTax
												)}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell sx={classes.tableRow}>Total Taxes:</TableCell>
											<TableCell sx={classes.tableRow}>
												{formatCurrency(invoiceDetails[0]?.totalTaxes)}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell sx={classes.tableRow}>
												Invoice Start Total:
											</TableCell>
											<TableCell sx={classes.tableRow}>
												{formatCurrency(
													invoiceDetails[0]?.invoiceStartTotalAmount
												)}
											</TableCell>
										</TableRow>
										{invoiceDetails[0]?.processingFee > 0 && (
											<TableRow>
												<TableCell sx={classes.tableRow}>
													Processing Fee:
												</TableCell>
												<TableCell sx={classes.tableRow}>
													{formatCurrency(invoiceDetails[0]?.processingFee)}
												</TableCell>
											</TableRow>
										)}
										{invoiceDetails[0]?.returnFee > 0 && (
											<TableRow>
												<TableCell sx={classes.tableRow}>Return Fee:</TableCell>
												<TableCell sx={classes.tableRow}>
													{formatCurrency(invoiceDetails[0]?.returnFee)}
												</TableCell>
											</TableRow>
										)}
										{invoiceDetails[0]?.lateFee > 0 && (
											<TableRow>
												<TableCell sx={classes.tableRow}>Late Fee:</TableCell>
												<TableCell sx={classes.tableRow}>
													{formatCurrency(invoiceDetails[0]?.lateFee)}
												</TableCell>
											</TableRow>
										)}
										{invoiceDetails[0]?.totalDiscount > 0 && (
											<TableRow>
												<TableCell sx={classes.tableRow}>
													Total Discounts:
												</TableCell>
												<TableCell sx={classes.tableRow}>
													{formatCurrency(invoiceDetails[0]?.totalDiscount)}
												</TableCell>
											</TableRow>
										)}
										{invoiceDetails[0]?.refunds > 0 && (
											<TableRow>
												<TableCell sx={classes.tableRow}>Refunds:</TableCell>
												<TableCell sx={classes.tableRow}>
													{formatCurrency(invoiceDetails[0]?.refunds)}
												</TableCell>
											</TableRow>
										)}
										<TableRow>
											<TableCell sx={classes.tableRow}>Total Paid:</TableCell>
											<TableCell sx={classes.tableRow}>
												{formatCurrency(invoiceDetails[0]?.amountPaid)}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell sx={classes.tableRow}>Balance Due:</TableCell>
											<TableCell sx={classes.tableRow}>
												{formatCurrency(invoiceDetails[0]?.balanceDue)}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</Grid>
							<Grid container>
								<Grid size={{xs: 12}} sx={{...classes.tableHeader}}>
									Payment Details
								</Grid>
							</Grid>
							<TableContainer sx={{ overflowX: "auto" }}>
								<Table
									sx={{ "& .MuiTableCell-root": { ...classes.tableCell } }}
								>
									<TableHead>
										<TableCell sx={{ minWidth: 80 }}>Date</TableCell>
										<TableCell>Amount</TableCell>
										<TableCell>Complete</TableCell>
										<TableCell>Type</TableCell>
										<TableCell>Method</TableCell>
										<TableCell>Code</TableCell>
										<TableCell style={{ textAlign: "right", minWidth: 200 }}>
											Fields
										</TableCell>
									</TableHead>
									<TableBody>
										{invoiceDetails[0]?.invoiceHistoryItems?.map(
											(payment: any, index: any) => (
												<TableRow
													key={index}
													sx={{
														verticalAlign: "text-top",
														borderBottom: "1px solid gray",
													}}
												>
													<TableCell>
														{dayjs(payment.date.slice(0, 10)).format(
															"MM/DD/YYYY"
														)}
													</TableCell>
													<TableCell style={{ textAlign: "left" }}>
														{formatCurrency(payment.amount)}
													</TableCell>
													<TableCell>
														{payment.approved ? "True" : "False"}
													</TableCell>
													<TableCell>{payment.paymentKind}</TableCell>
													<TableCell>{payment.paymentMethod}</TableCell>
													<TableCell>{payment.code}</TableCell>
													<TableCell style={{ textAlign: "right" }}>
														{payment?.properties
															? Object.entries(
																	payment?.properties?.map((property: any) => {
																		return property
																	})
															  ).map((property: any, index: any) => {
																	return (
																		<span key={index}>
																			{property[1].field}: {property[1].value}
																			<br />
																		</span>
																	)
															  })
															: null}
													</TableCell>
												</TableRow>
											)
										)}
									</TableBody>
								</Table>
							</TableContainer>
						</DialogContentText>
					</DialogContent>
				</>
			) : (
				<Loader />
			)}
		</>
	)
}
